import React, { useMemo, useState } from "react";
import {
  Dropdown as DropdownRS,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { Direction } from "reactstrap/es/Dropdown";

type Props = {
  selectedValues?: number[];
  options: { id: number; name: string }[];
  size?: "sm";
  direction?: Direction;
  type: string;
  onChange: (val: { id: number; name: string }[]) => void;
  loading?: boolean;
};

const DropDown = ({
  size,
  direction,
  selectedValues,
  options,
  type,
  onChange,
  loading
}: Props) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const selectVal = useMemo(
    () => options.filter((e) => selectedValues?.includes(e.id)),
    [options, selectedValues]
  );
  return (
    // <DropdownRS
    //   size={size || "sm"}
    //   isOpen={showDropDown}
    //   direction={direction || "down"}
    //   toggle={() => setShowDropDown((prevState) => !prevState)}
    // >
    //   <DropdownToggle caret>
    //     {selectVal.length > 0 ? (
    //       <span>
    //         {type}:
    //         <span className="text-primary text-capitalize px-2">
    //           {selectVal?.length} selected
    //         </span>
    //       </span>
    //     ) : (
    //       <span>{`Select ${type || "value"}`}</span>
    //     )}
    //   </DropdownToggle>
    //   <DropdownMenu>
    //     {options?.length !== 0 ? (
    //       options?.map((each, index) => {
    //         let isSelected = selectVal.findIndex((e) => e?.id === each.id);
    //         return (
    //           <DropdownItem
    //             key={index}
    //             onClick={(e) => {
    //               e.preventDefault();
    //               e.stopPropagation();
    //               // onChange(each);
    //               if (isSelected === -1) {
    //                 onChange([...selectVal, each]);
    //               } else {
    //                 onChange(selectVal.filter((e) => e.id !== each?.id));
    //               }
    //             }}
    //           >
    //             <span className="d-flex justify-content-between align-items-center">
    //               {each?.name}
    //               {isSelected !== -1 && (
    //                 <i className="fas fa-check-circle text-primary"></i>
    //               )}
    //             </span>
    //           </DropdownItem>
    //         );
    //       })
    //     ) : (
    //       <span className="small text-muted text-center">
    //         No {type || "Options"} Available
    //       </span>
    //     )}
    //   </DropdownMenu>
    // </DropdownRS>
    <DropdownRS
      size={size || "sm"}
      isOpen={showDropDown}
      direction={direction || "down"}
      toggle={() => setShowDropDown((prevState) => !prevState)}
    >
      <DropdownToggle caret>
        {selectVal?.length > 0 ? (
          <span>
            Selected Topics:{" "}
            <span className="text-primary">{selectVal?.length}</span>
          </span>
        ) : type}
      </DropdownToggle>
      <DropdownMenu style={{ maxHeight: 300, overflow: "auto" }}>
        {selectVal?.length > 0 ? (
          <DropdownItem
            className="d-flex justify-content-center align-items-center font-weight-bold bg-light"
            onClick={() => {
              onChange([]);
            }}
          >
            Clear All <i className="fas fa-times-circle text-danger ml-1"></i>
          </DropdownItem>
        ) : (
          <></>
        )}
        {loading
          ?
          <Spinner size={"sm"} />
          :
          options?.length !== 0 ? (
            options?.map((each, index) => {
              let isSelected = selectVal.findIndex((e) => e?.id === each.id);
              return (
                <DropdownItem
                  key={index}
                  onClick={() => {
                    if (isSelected === -1) {
                      onChange([...selectVal, each]);
                    } else {
                      onChange(selectVal.filter((e) => e.id !== each?.id));
                    }
                  }}
                >
                  <span className="d-flex justify-content-between align-items-center">
                    {each?.name}
                    {selectVal?.filter((e) => e.id === each.id)?.length ? (
                      <i className="fas fa-check-circle text-primary ml-2 mr-1"></i>
                    ) : (
                      <></>
                    )}
                  </span>
                </DropdownItem>
              );
            })
          ) : (
            <span className="small text-muted text-center">
              Please select a grade and subject first
            </span>
          )}
      </DropdownMenu>
    </DropdownRS>
  );
};

export default DropDown;
